// extracted by mini-css-extract-plugin
module.exports = {"empty":"Empty_empty__2zh-P","div_100":"Empty_div_100__16I8d"};